import axios from 'axios';
import { BACKEND_URL } from './config';

const API_URL = `${BACKEND_URL}/api/v1/admin`;
const login = (email, password) => {
  return axios
    .post(API_URL + '/login', {
      email,
      password,
    })
    .then((response) => {
      if (response.data.token) {
        localStorage.setItem('token', JSON.stringify(response.data.token));
      }

      return response.data;
    });
};

const logout = () => {
  localStorage.removeItem('token');
};

const getCurrentUser = () => {
  return JSON.parse(localStorage.getItem('token'));
};

const authService = {
  login,
  logout,
  getCurrentUser,
};

export default authService;
